module.exports = __webpack_public_path__ + "static/media/lock-icon.7508bc20.svg";